<script setup lang="ts">
import { computed } from 'vue'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { library } from '@fortawesome/fontawesome-svg-core'
library.add(faSpinner)

defineEmits(['clicked'])

const props = defineProps({
    label: {
        type: String,
        default: ''
    },
    icon: {
        default: null
    },
    buttonType: {
        type: String,
        default: 'primary'
    },
    textSize: {
        type: String,
        default: 'text-xs'
    },
    fontType: {
        type: String,
        default: 'font-medium'
    },
    paddingClasses: {
        type: String,
        default: 'py-2.5 px-5'
    },
    marginClasses: {
        type: String,
        default: ''
    },
    disabled: {
        type: Boolean,
        default: false
    },
    loading: {
        type: Boolean,
        default: false
    }
})

const spinner = computed(() => faSpinner)

const buttonClass = computed(() => {
    switch (props.buttonType) {
        case 'primary':
            return 'btn-primary cursor'
        case 'secondary':
            return 'btn-secondary cursor'
        case 'danger':
            return 'btn-danger cursor'
        case 'success':
            return 'btn-success cursor'
        case 'primary-outline':
            return 'btn-primary-outline cursor'
        case 'secondary-outline':
            return 'btn-secondary-outline cursor'
        case 'danger-outline':
            return 'btn-danger-outline cursor'
        case 'success-outline':
            return 'btn-success-outline cursor'
        default:
            return 'btn-primary cursor'
    }
})
</script>
<template>
    <button
        type="button"
        @click.prevent="$emit('clicked')"
        :disabled="disabled || loading"
        :aria-busy="loading ? 'true' : undefined"
        style="text-wrap: nowrap"
        :class="`${buttonClass} ${textSize} ${fontType} ${paddingClasses} ${marginClasses}`"
    >
        <!-- The label stays put while loading. It used to be replaced by a bare
             spinner, so the button lost its meaning mid-request. -->
        <font-awesome-icon
            v-if="loading"
            :icon="spinner"
            class="fa-spin"
            :class="label ? 'mr-2' : ''"
        />
        <font-awesome-icon v-else-if="icon" :icon="icon" :class="label ? 'mr-2' : ''" />
        <span v-if="label">{{ label }}</span>
    </button>
</template>
<style scoped></style>
